import script from "./publisherTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./publisherTemp.vue?vue&type=script&setup=true&lang=js"

import "./publisherTemp.vue?vue&type=style&index=0&id=613de6c4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-613de6c4"]])

export default __exports__